import React, { useState } from 'react';
import { FiAlertCircle, FiX } from "react-icons/fi";
import '../styles/leagueManagement.css';

// Поля team_applications_ex, которые заводит админ.
// client_owner и comment проставляет бэкенд.
const DEFAULT_LIMIT = 30;

export default function NewApplicationForm({ existingNames, onSubmit, onCancel }) {
    const [name, setName] = useState('');
    const [year, setYear] = useState(String(new Date().getFullYear()));
    const [limit, setLimit] = useState('');
    const [priority, setPriority] = useState('1');
    const [active, setActive] = useState(true);
    const [canDouble, setCanDouble] = useState(false);
    const [error, setError] = useState(null);

    const parsedLimit = limit === '' ? null : parseInt(limit, 10);
    const parsedPriority = parseInt(priority, 10);

    const limitValid = limit === '' || (!isNaN(parsedLimit) && parsedLimit > 0);
    const priorityValid = !isNaN(parsedPriority) && parsedPriority > 0;

    const submit = () => {
        const trimmed = name.trim();
        if (!trimmed) {
            setError('Введите название заявки.');
            return;
        }
        if (existingNames.includes(trimmed)) {
            setError('Заявка с таким названием уже есть.');
            return;
        }
        if (!year.trim()) {
            setError('Укажите год.');
            return;
        }
        if (!limitValid) {
            setError('Лимит игроков должен быть числом больше 0 или пустым.');
            return;
        }
        if (!priorityValid) {
            setError('Приоритет должен быть числом больше 0.');
            return;
        }
        setError(null);
        onSubmit({
            name: trimmed,
            year: year.trim(),
            application_limit: parsedLimit,
            priority: parsedPriority,
            active: active ? 1 : 0,
            canDouble: canDouble ? 1 : 0,
        });
    };

    return (
        <div className="lmRow lmRowNested">
            <div className="seasonScopeNote">
                <FiAlertCircle style={{ marginRight: '8px', flexShrink: 0 }} />
                <span>
                    Новая заявка создаётся <strong>пустой</strong>: игроков в ней не будет
                    ни у одной команды. Капитанам придётся заявить своих игроков заново.
                </span>
            </div>

            <label className="modalLabel">Название заявки</label>
            <input
                type="text"
                className="modalInput"
                maxLength={100}
                value={name}
                placeholder="например «Кубок КФЛ 2026»"
                autoFocus
                onChange={(e) => setName(e.target.value)}
            />

            <label className="modalLabel lmLabelSpaced">Год</label>
            <input
                type="text"
                className="modalInput inputNarrow"
                maxLength={100}
                value={year}
                placeholder="2026"
                onChange={(e) => setYear(e.target.value)}
            />

            <label className="modalLabel lmLabelSpaced">Лимит игроков в заявке</label>
            <input
                type="number"
                className="modalInput inputNarrow"
                min={1}
                value={limit}
                placeholder={String(DEFAULT_LIMIT)}
                onChange={(e) => setLimit(e.target.value)}
            />
            <span className="fieldHint">
                Сколько игроков команда может заявить. Если оставить пустым, будет {DEFAULT_LIMIT}.
            </span>

            <label className="modalLabel lmLabelSpaced">Приоритет</label>
            <input
                type="number"
                className="modalInput inputNarrow"
                min={1}
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
            />
            <span className="fieldHint">
                Порядок заявки на странице команды: 1 — показывается первой, 2 — ниже и так далее.
            </span>

            <div className="switchRow lmLabelSpaced">
                <div className="switchText">
                    <span className="switchTitle">Заявка активна</span>
                    <span className="fieldHint">
                        Неактивная заявка остаётся в базе, но не предлагается командам.
                    </span>
                </div>
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={active}
                        onChange={(e) => setActive(e.target.checked)}
                    />
                    <span className="switchSlider" />
                </label>
            </div>

            <div className="switchRow lmLabelSpaced">
                <div className="switchText">
                    <span className="switchTitle">Игрок может играть за несколько команд</span>
                    <span className="fieldHint">
                        Если выключено, в рамках этой заявки игрок закреплён ровно за одной командой.
                    </span>
                </div>
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={canDouble}
                        onChange={(e) => setCanDouble(e.target.checked)}
                    />
                    <span className="switchSlider" />
                </label>
            </div>

            {error && <span className="fieldError">{error}</span>}

            <div className="inlineForm lmLabelSpaced">
                <button type="button" className="actionButtonSolid" onClick={submit}>
                    Создать заявку
                </button>
                <button type="button" className="iconButton" onClick={onCancel} title="Отмена">
                    <FiX />
                </button>
            </div>
        </div>
    );
}
